const types = {
  SET_CHANNEL_LIST: 'SET_CHANNEL_LIST',
};

export default types;
